import * as React from 'react';

import Modal from 'antd/lib/modal';
import { MailOutlined } from '@ant-design/icons';
import Space from 'antd/lib/space';
import Input, { InputProps } from 'antd/lib/input';

import RequestComponent, { RequestData } from '@common/react/smart components/RequestComponent';
import Button from '@common/react/components/Forms/Button';
import { ErrorMessageComponent, SuccessMessageComponent } from '@common/react/components/Messages/MessageComponent';

interface OwnProps extends InputProps {
	allowResend?: boolean;
	petId?: number;
	minified?: boolean;
	email: string;
}

export const PetMemorialEmailButton: React.FC<OwnProps> = (props: OwnProps) => {
	const {
		allowResend = false,
		petId = -1,
		minified = false,
		email,
		...domProps
	} = props;

	const button = (isLoading: boolean, action: () => void) => (
		<Button
			title="Send Memorial Email"
			loading={isLoading}
			type={minified ? 'text' : 'default'}
			size={minified ? 'small' : undefined}
			onClick={() => Modal.confirm({
				title: `Send memorial email to ${email}?`,
				okText: 'Send',
				onOk: action,
			})}
			disabled={!allowResend || !petId || petId < 0}
			icon={<MailOutlined />}
		>
			{minified ? 'Send Memorial Email' : null}
		</Button>
	);

	return (
		<RequestComponent endpoint="sendMemorialEmail" requestParams={{ petId }}>
			{
				(data: RequestData<void>) => (
					<>
						{
							data.item
								? (
									<SuccessMessageComponent
										message="Memorial email was successfully sent"
									/>
								) : null
						}
						<ErrorMessageComponent message={data.error}>
							{
								minified
									? button(data.isLoading, data.request)
									: (
										<Space.Compact
											block
											style={props.style}
										>
											<Input {...domProps} />
											{button(data.isLoading, data.request)}
										</Space.Compact>
									)
							}
						</ErrorMessageComponent>
					</>
				)
			}
		</RequestComponent>
	);
};
